import { Routes } from '@angular/router';
import { isLoggedInGuard } from './auth/guards/is-logged-in-guard/is-logged-in.guard';
import { isNotLoggedInGuard } from './auth/guards/is-not-logged-in-guard/is-not-logged-in.guard';
import { APP_ROUTE_PATH } from './core/enums/routes/app-route-path.enum';

export const APP_ROUTES: Routes = [
  {
    path: APP_ROUTE_PATH.login,
    loadComponent: () =>
      import('./pages/login-device-page/login-device-page.component').then(
        (m) => m.LoginDevicePageComponent
      ),
    canActivate: [isNotLoggedInGuard],
  },
  {
    path: APP_ROUTE_PATH.serviceConfiguration,
    loadComponent: () =>
      import('./features/service/presentation/components/service.component').then(
        (m) => m.ServiceComponent
      ),
    canActivate: [isLoggedInGuard],
  },
  {
    path: APP_ROUTE_PATH.service,
    loadChildren: () =>
      import('./pages/service/service.routes').then((m) => m.SERVICE_ROUTES),
    canActivate: [isLoggedInGuard],
  },
  {
    path: APP_ROUTE_PATH.info,
    loadChildren: () =>
      import('./pages/informative-page/informative-page.routes').then(
        (m) => m.INFORMATIVE_PAGE_ROUTES
      ),
    canActivate: [isLoggedInGuard],
  },
  {
    path: APP_ROUTE_PATH.healthCheck,
    loadChildren: () =>
      import('./pages/health-check-page/health-check-page.routes').then(
        (m) => m.HEALTH_CHECK_ROUTES
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: APP_ROUTE_PATH.login,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: APP_ROUTE_PATH.login,
  },
];
